export default __webpack_public_path__ + "static/media/BCA32.ca16fcb0.jpg";